import { useLanguage } from '@/i18n/LanguageContext';
import ScrollReveal from './ScrollReveal';

export default function Regions() {
    const { t } = useLanguage();

    return (
        <section className="px-4 py-8 lg:px-16 lg:py-12 xl:px-20">
            <ScrollReveal variant="fade-up" distance={36} duration={800}>
                <div className="overflow-hidden rounded-3xl bg-[#F5F5F5]">
                    {/* ─── Desktop Layout ─── */}
                    <div className="xl:pt-18 hidden px-12 pb-16 pt-14 lg:block xl:px-16 xl:pb-20">
                        {/* Top Row: description | globe | tagline */}
                        <div className="flex items-start gap-8 xl:gap-12">
                            {/* Left — Description */}
                            <ScrollReveal variant="fade-right" delay={200} distance={30}>
                                <p className="text-secondary max-w-sm shrink-0 pt-6 text-[15px] font-medium leading-[2] xl:max-w-md">
                                    {t('regions.description')}
                                </p>
                            </ScrollReveal>

                            {/* Center — Globe Illustration */}
                            <ScrollReveal
                                variant="scale"
                                delay={300}
                                duration={900}
                                className="flex flex-1 justify-center"
                            >
                                <img
                                    src="/assets/libs/2147224037.svg"
                                    alt="Globe showing Ghana, UK, and Nigeria"
                                    className="w-full max-w-sm object-contain xl:max-w-md"
                                />
                            </ScrollReveal>

                            {/* Right — Tagline */}
                            <ScrollReveal variant="fade-left" delay={200} distance={30}>
                                <p className="text-secondary max-w-60 shrink-0 pt-6 text-xl font-bold leading-snug xl:text-2xl">
                                    {t('regions.tagline')}
                                </p>
                            </ScrollReveal>
                        </div>

                        {/* Bottom — Large Heading */}
                        <ScrollReveal variant="blur-up" delay={400} duration={800}>
                            <h2 className="text-secondary mx-auto mt-10 max-w-4xl text-center text-[30px] font-extrabold leading-[1.2] tracking-tight xl:mt-14 xl:text-[50px]">
                                {t('regions.heading')}
                            </h2>
                        </ScrollReveal>
                    </div>

                    {/* ─── Mobile Layout ─── */}
                    <div className="px-6 pb-0 pt-8 lg:hidden">
                        {/* Heading */}
                        <ScrollReveal variant="fade-up" delay={0}>
                            <h2 className="text-secondary text-[26px] font-extrabold leading-[1.2] tracking-tight sm:text-[32px]">
                                {t('regions.heading')}
                            </h2>
                        </ScrollReveal>

                        {/* Description */}
                        <ScrollReveal variant="fade-up" delay={100}>
                            <p className="text-secondary mt-6 text-sm font-normal leading-[2] sm:text-base">
                                {t('regions.description')}
                            </p>
                        </ScrollReveal>

                        {/* Globe Illustration */}
                        <ScrollReveal variant="scale" delay={200} duration={800}>
                            <div className="-mx-2 mt-8">
                                <img
                                    src="/assets/libs/2147224037.svg"
                                    alt="Globe showing Ghana, UK, and Nigeria"
                                    className="w-full object-contain"
                                />
                            </div>
                        </ScrollReveal>
                    </div>
                </div>
            </ScrollReveal>
        </section>
    );
}
